import { render, staticRenderFns } from "./AssignStudentToClassModal.vue?vue&type=template&id=5c0505ae&scoped=true"
import script from "./AssignStudentToClassModal.vue?vue&type=script&lang=js"
export * from "./AssignStudentToClassModal.vue?vue&type=script&lang=js"
import style0 from "./AssignStudentToClassModal.vue?vue&type=style&index=0&id=5c0505ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0505ae",
  null
  
)

export default component.exports